export default {"src":"/_next/static/media/smile.ae1f9157.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};